import './IconMiniInfo.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
const IconMiniInfo = _ref => {
  let {
    width = 20,
    height = 20,
    className,
    fill
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    className: className
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "9",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.207 15.047) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.913,5.852A.912.912,0,0,1,0,4.939V.913a.913.913,0,1,1,1.826,0V4.939A.912.912,0,0,1,.913,5.852Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.886)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "1.095",
    cy: "1.095",
    r: "1.095",
    fill: "currentColor"
  }))));
};
const StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "sxcx9vn"
});
export default IconMiniInfo;